/* Project Import will be here */
import { post, IRequest } from "../index";
import { IRewardsProductListParams } from "models/rewardModels";
import { IApplyFilterParams } from "models/productModels";
/* Project Import will be here */

/* Get Rewards Product List Api */
export const getRewardsGiftProductsApi = (data: IApplyFilterParams) => {
  const request: IRequest = { subUrl: '/Reward/GetGiftProducts', data };
  return post(request);
};

/* Submit reward order API */
export const submitRewardOrderApi = (data) => {
  const request: IRequest = { subUrl: '/Reward/RewardOrderSubmit', data };
  return post(request);
};

/* Get Rewards Tabs */
export const getRewardTabsApi = () => {
  const request: IRequest = { subUrl: '/Reward/GetRewardTabs' };
  return post(request);
};

/* Get Rewards Dashboard Details */
export const getRewardDashboardApi = (data) => {
  const request: IRequest = { subUrl: '/Reward/GetRewardDashboard', data };
  return post(request);
};

/* Get Rewards Order Summary Api*/
export const getRewardsOrderHistoryApi = (data: IRewardsProductListParams) => {
  const request: IRequest = { subUrl: '/Reward/RedemptionView', data };
  return post(request);
};

/* Get Rewards History details Api*/
export const getRewardHistoryDetailsApi = (data) => {
  const request: IRequest = { subUrl: '/Reward/RedemptionViewDetails', data };
  return post(request);
};

export const rewardOrderConfirmRequestOTPApi = () => {
  const request: IRequest = { subUrl: `/Reward/RequestRewardOrderOTP` };
  return post(request);
};

export const rewardOrderConfirmValidateOTPApi = (data) => {
  const request: IRequest = { subUrl: `/Reward/ValidateRewardOrderOTP`, data };
  return post(request);
};

/* Get Vendors list Api*/
export const getRewardVendorListApi = () => {
  const request: IRequest = { subUrl: '/Reward/GetVendors' };
  return post(request);
};

/*Get Loyalty Dashboard Details*/
export const getLoyaltyDashboardDetailsApi = (data) => {
  const request: IRequest = { subUrl: `/Loyalty/GetLoyaltyDashboardDetails`, data };
  return post(request);
};

/* Submit Reward order Delivery Confirmation */
export const submitRewardDeliveryOrderConfirmationApi = (data) => {
  const request: IRequest = { subUrl: `/Reward/RewardDeliverySubmit`, data };
  return post(request);
};